function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.2,
      paintOrder: "stroke fill markers"
    },
    width: 56,
    height: 56,
    x: 4,
    y: 4,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffba08"
    },
    d: "M 60,31 V 56 C 60,57.662 58.662,59 57,59 H 30 V 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#459ee9"
    },
    d: "M 4,29 V 56 C 4,57.662 5.338,59 7,59 H 32 V 29 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eb572a"
    },
    d: "M 7,3 C 5.338,3 4,4.338 4,6 V 31 H 34 V 3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79a61c"
    },
    d: "M 57,3 C 58.662,3 60,4.338 60,6 V 31 H 32 V 3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#ffffff"
    },
    d: "M 7 3 C 5.338 3 4 4.338 4 6 L 4 7 C 4 5.338 5.338 4 7 4 L 57 4 C 58.662 4 60 5.338 60 7 L 60 6 C 60 4.338 58.662 3 57 3 L 7 3 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/Microsoft.a0b623ef4c1a3030aae5764c4bde33c8.svg";
export { ForwardRef as ReactComponent };